import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './ExamPlanning.css'
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import _ from 'underscore';
import { Calendar } from 'primereact/calendar';
import { AgGridReact } from '@ag-grid-community/react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useExam } from '../../../Hooks/Features/ExamPlanning/useExam';
import { useCommon } from '../../../Hooks/Common/useCommon.js';
import { SkeletonLine } from '../../../components/Loader/Loader.jsx';

function ExamPlanning() {

    const { checkPermission } = useCommon();
    const { tagRef, techOptions, filterTech, setFilterTech, handleCreateNew, dataFlag, examsList, handleGetExamDetails, actionOf, setActionOf, showAction, setShowAction, handleEditExam, handleDeleteExam, showExam, examInfo, showUserDetails, examUser, columnDefs1, rowDatas1, handleParticipantClick, gridRef, columnDefs, handleSetRemark, rowDatas, remarks, newExamDialog, setNewExamDialog, isNewExam, name, setName, technologySelected, setTechnologySelected, levelOpt, level, setLevel, quesOptions, questionsSelected, setQuestionsSelected, dates, dateSelected, handleDateChange, userOptions, userSelected, setUserSelected, handleAddDate, handleUpsertNewExam } = useExam();

    return (
        <div ref={() => checkPermission("Training", tagRef)}>
            <div className='row' ref={tagRef} id='{"tabname": "training", "data": "exam_planning_li"}'>
                <div className='col-md-3 col-12'>
                    <div className='exam-container-left'>
                        <div style={{    padding: "10px", marginBottom: '10px' }}>
                            <div className='row'>
                                <div className='col-md-7 col-12'>
                                    <Dropdown className='w100' placeholder='Technologies' options={techOptions} optionLabel='tech_name' value={filterTech} onChange={(e) => setFilterTech(e.target.value)} filter filterInputAutoFocus showClear={_.isEmpty(filterTech) ? false : true} />
                                </div>
                                <div className='col-md-5 col-12 text-right'>
                                    <button onClick={() => handleCreateNew()}><FontAwesomeIcon icon="fa-solid fa-plus" /> Exam</button>
                                </div>
                            </div>
                        </div>
                        <div className='exam-list'>
                            {dataFlag ? examsList.map((exam) => (
                                <div className='exam-card' key={exam.exam_id} onClick={() => handleGetExamDetails(exam)} onMouseEnter={() => { setActionOf(exam.exam_id); setShowAction(true) }} onMouseLeave={() => { setActionOf(""); setShowAction(false) }}>
                                    <div className='exam-info'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <h5>{exam.exam_name}</h5>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <span className='exam-tech'>{exam.tech_name}</span>
                                            </div>

                                            <div className='col-md-6'>
                                                <span className='result'><span className='tot'>40</span>/<span className='att'>30</span>/<span className='pass'>20</span>/<span className='fail'>10</span></span>
                                            </div>
                                        </div>
                                    </div>
                                    {showAction && actionOf === exam.exam_id && (
                                        <div className='exam-actions'>
                                            <FontAwesomeIcon className='icon-btn-secondary' icon="fa-solid fa-pen" onClick={() => handleEditExam(exam)} />
                                            <FontAwesomeIcon className='icon-btn-secondary' icon="fa-solid fa-trash" onClick={() => handleDeleteExam(exam)} />
                                        </div>
                                    )}
                                </div>
                            )) : <SkeletonLine numSkeletons={6} />}
                        </div>
                    </div>
                </div>
                <div className='col-md-9 col-12'>
                    {showExam && (
                        <div className='exam-details'>
                            <div className='row'>
                                <div className='col-md-6 col-12 exam-title-container'>
                                    <h5 className='exam-title'>{examInfo?.exam_name} - [{examInfo?.tech_name}] </h5>
                                </div>
                                <div className='col-md-6 col-12 exam-title-container text-right'>
                                    {showUserDetails && (<h6 className='exam-subtitle'><b>{examUser.user_display_name}</b> - [{examUser.employee_id}]</h6>)}
                                </div>
                            </div>
                            <div className='exam-tables-container'>
                                <div className='row'>
                                    <div className='col-md-7 col-12 '>
                                        {/* <div className='row'>
                                            <div className='col-md-12 col-12 '>
                                                <h6 className='exam-subtitle'><b>Java Script</b> - Exam Details</h6>
                                            </div>
                                        </div> */}
                                        <div className='row'>
                                            <div className='col-md-12 col-12 paddl0'>
                                                <div className='exam-users-table ag-theme-alpine'>
                                                    <AgGridReact
                                                        rowHeight={24}
                                                        headerHeight={30}
                                                        columnDefs={columnDefs1}
                                                        rowData={rowDatas1}
                                                        onRowClicked={(e) => handleParticipantClick(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-12 '>
                                        <div className='row'>
                                            <div className='col-md-12 col-12 '>
                                                <div className='exam-users-table'>
                                                    {showUserDetails && (
                                                        <div className='exam-details-table ag-theme-alpine'>
                                                            {/* <div className='row'>
                                                                <div className='col-md-12 col-12 '>
                                                                    <h6 className='exam-subtitle'><b>{examUser.user_display_name}</b> - [{examUser.employee_id}]</h6>
                                                                </div>
                                                            </div> */}
                                                            <AgGridReact
                                                                rowHeight={24}
                                                                headerHeight={30}
                                                                columnDefs={columnDefs}
                                                                rowData={rowDatas}
                                                                ref={gridRef}
                                                            />
                                                            <div>
                                                                <textarea type='text' placeholder='Enter Remarks' rows={3} style={{ width: "100%" }} onBlur={(e) => handleSetRemark(e.target.value)} defaultValue={remarks} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div>
                    <Dialog onHide={() => setNewExamDialog(false)} visible={newExamDialog} draggable={false} style={{ width: "30%" }} header={isNewExam ? "Create New Exam" : "Edit Exam"} className='exam-create-popup'>
                        <div className='exam-new-popup'>
                            <input placeholder='Enter exam name' value={name} onChange={(e) => setName(e.target.value)} />
                            <Dropdown placeholder='Select Technology' value={technologySelected} onChange={(e) => setTechnologySelected(e.target.value)} options={techOptions} optionLabel='tech_name' filter filterInputAutoFocus /><br />
                            <Dropdown options={levelOpt} optionLabel='name' value={level} onChange={(e) => setLevel(e.target.value)} placeholder='Select exam level' filter filterInputAutoFocus />
                            <MultiSelect options={quesOptions} optionLabel="question_title" value={questionsSelected} onChange={(e) => setQuestionsSelected(e.target.value)} filter filterInputAutoFocus placeholder='Select Questions' />
                            <div>
                                {dates.map((_, index) => (
                                    <div key={index} className='exam-date-options'>
                                        <Calendar value={dateSelected[index]} onChange={(e) => handleDateChange(index, e)} placeholder='Select Date' className='exam-popup-date' dateFormat="dd-mm-yy" />
                                        <MultiSelect options={userOptions} optionLabel="user_display_name" value={userSelected[index]} onChange={(e) => setUserSelected((prev) => ({ ...prev, [index]: e.target.value }))} filter filterInputAutoFocus placeholder='Select Users' className='exam-popup-users' />
                                    </div>
                                ))}
                                {/* <DatePicker value={dateSelected} onChange={setDateSelected}/>
                            <MultiSelect options={userOptions} optionLabel="user_display_name" value={userSelected} onChange={(e) => setUserSelected(e.target.value)} filter filterInputAutoFocus placeholder='Select Users'/> */}
                                <div className='exam-date-plus' onClick={handleAddDate}>
                                    <FontAwesomeIcon icon="fa-solid fa-plus" />
                                    <span> Add dates</span>
                                </div>
                            </div>

                            <div className='exam-save-btn'><button onClick={handleUpsertNewExam}>Save</button></div>
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    )
}

export default ExamPlanning